export default {
  exportUnit: 'Exporteinheit',
};
